<script lang="ts">
	import { page } from '$app/state';
	import { sanitizeHtml } from '$lib/utils';

	interface Props {
		ribbon: string[];
	}

	const { ribbon }: Props = $props();
</script>

<div
	class="ribbon ribbon--count-{ribbon.length}"
	style:background-color={page.data.page.layout.ribbonBackgroundColor}
>
	<div class="ribbon-container container">
		{#each ribbon as ribbonItem}
			<div class="ribbon-item">
				{@html sanitizeHtml(ribbonItem)}
			</div>
		{/each}
	</div>
</div>

<style lang="postcss" global>
	html:has(.ribbon) {
		--ribbon-height: 60px;

		@media (--xxs) {
			--ribbon-height: 56px;
		}

		@media (--sm) {
			--ribbon-height: 44px;
		}

		@media (--lg) {
			--ribbon-height: 40px;
		}
	}

	.ribbon {
		& {
			display: flex;
			align-items: center;
			height: var(--ribbon-height, 60px);
			background-color: var(--ribbon-bg-color);
		}

		&-container {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			padding-block: 16px;
			gap: 24px 16px;
		}

		&-item {
			display: flex;
			font-size: 12px;
			line-height: 1;
			color: var(--color-brown);
		}

		@media (--xxs) {
			&-container {
				gap: 24px;
			}
		}

		@media (--sm) {
			&-container {
				gap: 24px;
			}
		}

		@media (--lg) {
			&-container {
				gap: 40px;
				padding-block: 13px;
			}

			&-item {
				font-size: 14px;
			}
		}

		@media (--xl) {
			&-container {
				gap: 60px;
			}
		}
	}
</style>
